export const FF_FRAMING_CAROUSEL = 'framing-carousel';
export const FF_FRAMING_PRESELECTION = 'framing-preselection';
